import React from "react";
import { FaqsTab } from "../../components";
const AllFaqs = () => {
  return (
    <>
      <div className="container faqs__box_list">
        <div className="row">
          <div className="col-lg-12 mt-5">
           <FaqsTab/>
              
          </div>
        </div>
      </div>
    </>
  );
};

export default AllFaqs;
